import { request } from '../util/http';
import { loggingServicePublishUrl, loggingServiceCorsUrl } from '../constant/index';
import { isAirwallexDomain } from '../util/index';
import { safeStringify } from '../util/jsonHelper';
export const sendNormalLogPipe = (airTracker) => {
    return (logs) => {
        const finalLog = {
            commonData: airTracker.commonData,
            data: Array.isArray(logs) ? logs : [logs],
        };
        const dataBody = safeStringify(finalLog);
        const sendOptions = {
            method: 'post',
            url: isAirwallexDomain()
                ? loggingServiceCorsUrl(airTracker.commonData.env)
                : loggingServicePublishUrl(airTracker.commonData.env),
            data: dataBody,
        };
        request(sendOptions);
    };
};
